import {
  HasVocalsCheckbox,
  Language,
  VocalistName,
  VocalsContent,
} from './components';

type PropsType = {
  releaseId: string;
};

const VocalsOptions = ({ releaseId }: PropsType) => (
  <>
    <HasVocalsCheckbox releaseId={releaseId} />
    <VocalsContent releaseId={releaseId} />
    <Language releaseId={releaseId} />
    <VocalistName releaseId={releaseId} />
  </>
);

export default VocalsOptions;
